module.exports = __webpack_public_path__ + "img/edf_pulse_grand_est.4e7b9194.png";